import { render, staticRenderFns } from "./accidentStaticPie.vue?vue&type=template&id=08cd97f7&scoped=true&"
import script from "./accidentStaticPie.vue?vue&type=script&lang=js&"
export * from "./accidentStaticPie.vue?vue&type=script&lang=js&"
import style0 from "./accidentStaticPie.vue?vue&type=style&index=0&id=08cd97f7&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cd97f7",
  null
  
)

export default component.exports